import { Component } from "react";
import { AlertTriangle } from "lucide-react";

export class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidUpdate(prev) { if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null }); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="m-6 rounded-lg border border-red-200 bg-red-50 p-5" data-testid="page-error">
        <div className="flex items-center gap-2 text-red-800 font-bold text-sm"><AlertTriangle className="w-4 h-4" /> Bu ekran beklenmeyen bir hatayla karşılaştı</div>
        <pre className="mt-2 text-[11px] text-red-700 whitespace-pre-wrap break-words max-h-40 overflow-auto" data-testid="page-error-detail">{String(this.state.error?.message || this.state.error)}</pre>
        <button type="button" onClick={() => this.setState({ error: null })} data-testid="page-error-retry" className="mt-3 px-3 py-1.5 rounded bg-red-700 text-white text-xs font-semibold hover:bg-red-800">Tekrar Dene</button>
      </div>
    );
  }
}
